// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1___904df5c8a10531f7213","cls2":"ConfirmationModal-cls2___3b8c9eaedf66cc4cdfe ConfirmationModal-cls1___904df5c8a10531f7213"};